export var CustomDimensionId;
(function (CustomDimensionId) {
    CustomDimensionId[CustomDimensionId["ScreenReaderEnabled"] = 1] = "ScreenReaderEnabled";
    CustomDimensionId[CustomDimensionId["PrefersReducedMotion"] = 2] = "PrefersReducedMotion";
    CustomDimensionId[CustomDimensionId["DynamicFontSize"] = 3] = "DynamicFontSize";
    CustomDimensionId[CustomDimensionId["ColorScheme"] = 4] = "ColorScheme";
    CustomDimensionId[CustomDimensionId["DeviceOrientation"] = 5] = "DeviceOrientation";
})(CustomDimensionId || (CustomDimensionId = {}));
